import axios from "axios";

// Drop-in replacement for the plain `axios` import used across the app.
// Every request automatically carries the admin's JWT (stored in
// localStorage after /admin/login), and a 401 response (missing/expired/
// invalidated token) clears the stale token and bounces to the sign-in page.
const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("auth_token");

      const path = window.location.pathname;
      if (!path.startsWith("/auth")) {
        window.location.href = "/auth/SignUp";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
